export const numberWithSeparator = (numStr) => {
	try {
		const numeroParseado = parseFloat(numStr);
		if (isNaN(numeroParseado)) {
			return "No es un número válido";
		}

		const formatoNumerico = new Intl.NumberFormat("es-AR");
		const numeroFormateado = formatoNumerico.format(numeroParseado);

		return numeroFormateado;
	} catch (error) {
		return "Error al formatear el número";
	}
}